<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <inertia-link
                        class="bg-gray-300 hover:bg-gray-500 text-black py-1 px-3 mx-3 rounded my-0"
                        :href="route('qr-codes.index')">
                        <i class="fas fa-arrow-left mx-1"></i> Voltar
                    </inertia-link>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    QR Codes PIX registrados
                </h2>
            </div>
        </template>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000"/>

                <template>
                    <jet-form-section>
                        <template #title>
                            Dados da cobrança
                        </template>

                        <template #description>
                            Utilize o qr-code ao lado ou copie e cole o código para pagamento
                        </template>

                        <template #form>
                            <div class="col-span-2 sm:col-span-2">
                                <img v-if="qrcode.qrcode.base64_content" :src="`data:image/png;base64, ${qrcode.qrcode.base64_content}`" />
                                <img v-else class="w-full" :src="qrcode.qrcode.url"/>
                            </div>
                            <div class="col-span-4 sm:col-span-4 pt-5">
                                <jet-label for="payer_street" value="Status" class="font-bold"/>
                                <div class="mb-2">{{ getStatus(qrcode.status) }}</div>

                                <jet-label for="payer_street" value="Pagador" class="font-bold"/>
                                <div class="mb-2">{{ qrcode.payer.name }}</div>

                                <jet-label for="payer_street" value="Documento" class="font-bold"/>
                                <div class="mb-2">{{ qrcode.payer.federal_document }}</div>

                                <jet-label for="payer_street" value="Código copia e cola" class="font-bold"/>
                                <div class="text-xs mt-2">
                                    <textarea class="w-full h-20">{{ qrcode.qrcode.copy_paste }}</textarea>
                                </div>

                            </div>

                        </template>
                    </jet-form-section>
                </template>

                <jet-section-border/>

            </div>

        </div>

    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import JetFormSection from "../../Jetstream/FormSection";
import JetInput from "../../Jetstream/Input";
import JetTextarea from "../../Jetstream/Textarea";
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import JetInputError from "../../Jetstream/InputError";
import JetLabel from "../../Jetstream/Label";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import JetFetchDoc from "../../Jetstream/FetchDoc";
import JetDatePicker from "../../Jetstream/DatePicker";
import JetRadio from "../../Jetstream/Radio";
import JetDecimal from "../../Jetstream/Decimal";
import JetConfirmationModal from "../../Jetstream/ConfirmationModal";
import JetDangerButton from "../../Jetstream/DangerButton";
import JetOkButton from "../../Jetstream/OkButton";
import Flash from "../../Helpers/Flash"
import moment from 'moment/dist/moment';

export default {
    props: ['goal_list', 'errors', 'qrcode'],
    methods: {
        getStatus(status) {
            try {
                return this.status[status];
            } catch (err) {
                return 'Indefinido';
            }
        }
    },
    data() {
        return {
            moment: moment,
            flashIsVisible: true,
            status: {
                pending: 'Pendente',
                paid: 'Pago',
                expired: 'Vencido',
                canceled: 'Cancelado'
            }
        }
    },
    components: {
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetRadio,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        JetDatePicker,
        JetDecimal,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton
    },
}
</script>
